(function() {
    'use strict';

    angular
        .module('serviciosocialApp')
        .controller('AlumnoUadyMatriculadoDeleteController',AlumnoUadyMatriculadoDeleteController);

    AlumnoUadyMatriculadoDeleteController.$inject = ['$uibModalInstance', 'entity', 'AlumnoUadyMatriculado'];

    function AlumnoUadyMatriculadoDeleteController($uibModalInstance, entity, AlumnoUadyMatriculado) {
        var vm = this;

        vm.alumnoUadyMatriculado = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            AlumnoUadyMatriculado.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
